/* VESPER LUNA — Wishlist (LocalStorage)
   Persists across page loads in same browser/device.
   All DOM operations use createElement + textContent (no innerHTML — XSS safe). */
(function () {
  'use strict';

  var KEY = 'vl_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* quota exceeded or storage disabled — fail silently */
    }
    syncBadges();
    document.dispatchEvent(
      new CustomEvent('vl:wishlist-change', { detail: { items: items } })
    );
  }

  function has(id) {
    return read().some(function (it) {
      return String(it.id) === String(id);
    });
  }

  function add(item) {
    var items = read();
    var exists = items.some(function (it) {
      return String(it.id) === String(item.id);
    });
    if (!exists) {
      items.unshift(Object.assign({ addedAt: Date.now() }, item));
      write(items);
    }
  }

  function remove(id) {
    write(
      read().filter(function (it) {
        return String(it.id) !== String(id);
      })
    );
  }

  function toggle(item) {
    if (has(item.id)) {
      remove(item.id);
      return false;
    }
    add(item);
    return true;
  }

  function syncBadges() {
    var count = read().length;
    var badges = document.querySelectorAll('[data-vl-wishlist-badge]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(count);
      badges[i].toggleAttribute('hidden', count === 0);
    }
    var buttons = document.querySelectorAll('[data-vl-wishlist-toggle]');
    for (var j = 0; j < buttons.length; j++) {
      var active = has(buttons[j].getAttribute('data-product-id'));
      buttons[j].setAttribute('aria-pressed', active ? 'true' : 'false');
      buttons[j].classList.toggle('is-active', active);
    }
  }

  function initToggleButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vl-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var item = {
        id: btn.getAttribute('data-product-id'),
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        image: btn.getAttribute('data-product-image'),
        price: btn.getAttribute('data-product-price'),
        url: btn.getAttribute('data-product-url')
      };
      toggle(item);
    });
  }

  /* DOM-safe card builder — no innerHTML */
  function createCard(it) {
    var article = document.createElement('article');
    article.className = 'vl-wishlist-card';
    article.setAttribute('data-product-id', String(it.id || ''));

    var mediaLink = document.createElement('a');
    mediaLink.href = it.url || '#';
    mediaLink.className = 'vl-wishlist-card__media';
    var img = document.createElement('img');
    img.src = it.image || '';
    img.alt = it.title || '';
    img.loading = 'lazy';
    mediaLink.appendChild(img);
    article.appendChild(mediaLink);

    var body = document.createElement('div');
    body.className = 'vl-wishlist-card__body';

    var titleLink = document.createElement('a');
    titleLink.href = it.url || '#';
    titleLink.className = 'vl-wishlist-card__title';
    titleLink.textContent = it.title || '';
    body.appendChild(titleLink);

    var price = document.createElement('span');
    price.className = 'vl-wishlist-card__price';
    price.textContent = it.price || '';
    body.appendChild(price);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'vl-wishlist-card__remove';
    removeBtn.setAttribute('data-vl-wishlist-toggle', '');
    var keys = ['id', 'handle', 'title', 'image', 'price', 'url'];
    for (var k = 0; k < keys.length; k++) {
      removeBtn.setAttribute(
        'data-product-' + keys[k],
        String(it[keys[k]] || '')
      );
    }
    removeBtn.textContent = 'Favorilerden çıkar';
    body.appendChild(removeBtn);

    article.appendChild(body);
    return article;
  }

  function renderPage() {
    var grid = document.querySelector('[data-vl-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-vl-wishlist-empty]');

    function rerender() {
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      var items = read();
      if (items.length === 0) {
        if (empty) empty.removeAttribute('hidden');
        return;
      }
      if (empty) empty.setAttribute('hidden', '');
      for (var i = 0; i < items.length; i++) {
        grid.appendChild(createCard(items[i]));
      }
    }

    rerender();
    document.addEventListener('vl:wishlist-change', rerender);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initToggleButtons();
    syncBadges();
    renderPage();
  });

  window.VlWishlist = {
    read: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle
  };
})();
